type Environment = {
  REACT_APP_ROLLBAR_TOKEN: string;
  REACT_APP_URL: string;
  FIGMA_ACCESS_TOKEN: string;
};

type WindowEnvironment = Window & typeof globalThis & { _env_?: Environment };

/**
 * Function to retrieve the environment variables. The variables are pulled from the window object
 * in production and process.env in development.
 * @returns {Environment} - The environment variables
 */
export default function getEnvironment(): Environment {
  if (process.env.NODE_ENV === "production") {
    const windowEnv: WindowEnvironment = window;
    return windowEnv._env_;
  }
  return {
    REACT_APP_ROLLBAR_TOKEN: process.env.REACT_APP_ROLLBAR_TOKEN,
    REACT_APP_URL: process.env.REACT_APP_URL,
    FIGMA_ACCESS_TOKEN: process.env.REACT_APP_FIGMA_TOKEN,
  };
}
